<template>
  <div class="form-group form-row">
    <label :for="safeId('name')" class="col-sm-4 col-form-label">Name</label>
    <div class="col-sm-8">
      <input type="text" class="form-control" :id="safeId('name')" v-model.lazy="name">
    </div>
  </div>
</template>

<script>
  import * as action from '@/store/action-types'

  export default {
    name: 'template-setting-name',
    props: {
      templateId: {
        type: String,
        required: true
      }
    },
    computed: {
      name: {
        get: function () {
          return this.$store.getters.template(this.templateId).name
        },
        set: function (val) {
          this.$store.dispatch(action.TEMPLATE_NAME, {
            templateId: this.templateId,
            name: val
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/template-settings/template-setting-name.vue